import { TitleTextItemInterface } from '@/types/newTypes'
import React from 'react'
import TryButton from './TryButton'

const RoadmapList = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const items: TitleTextItemInterface[] = [
    {
      title: 'Simply open Clean Master',
      text: 'Grant access to your photo gallery – rest assured, you retain full control over which photos to choose, and your privacy is fully protected',
    },
    {
      title: 'Review suggestions',
      text: 'The app will provide smart suggestions on what to delete. You can swipe through them to decide which ones to keep or remove',
    },
    {
      title: 'Clean up your gallery',
      text: 'With one tap, delete all selected photos, free up storage, and enjoy a more organized photo library',
    },
  ]

  return (
    <section className="w-full mb-14 relative before:absolute before:w-full before:h-full before:-top-[125px] before:left-0 before:bg-contain before:bg-roadmapListBg before:bg-no-repeat">
      <h2 className="text-center text-XL font-bold mb-6">How it works: easy and fun</h2>
      <ol className="max-w-minimum mx-auto w-full">
        {items.map((item, index) => (
          <li
            key={index}
            className="pl-14 flex flex-col gap-1 pb-6 relative before:absolute before:w-10 before:h-10 before:rounded-xl before:top-0 before:left-0 before:bg-roadmapMarkerBg after:absolute after:h-full after:w-[0.2px] after:-z-[1] after:border-l after:border-dashed after:border-lightBlue after:top-0 after:left-5 after:-translate-x-1/2 last-of-type:after:h-0"
          >
            <small className="absolute pointer-events-none z-[1] text-roadmapMarker text-white/80 font-webSafeSegoe font-semibold top-5 left-5 -translate-x-[48%] -translate-y-1/2">
              {index + 1}
            </small>
            <h3 className="text-LXL font-bold">{item.title}</h3>
            <p className="text-ML text-white70">{item.text}</p>
          </li>
        ))}
      </ol>
      <div className="max-w-[343px] mx-auto w-full">
        <TryButton to={isWhitePage ? '/email' : '/scan-results'} />
      </div>
    </section>
  )
}

export default RoadmapList
